import { useContext } from "react";
import { VisitorBookingContext } from "../VisitorBookingContextProvider";

const useVisitorBookingContext = () => useContext(VisitorBookingContext);

export default useVisitorBookingContext;
